import { useForm } from "antd/es/form/Form";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { Card, Form, Input, notification, Select } from "antd";
import { useParams } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import moment from "moment";
import { OFFER_PRODUCT_BUSINESS_TYPE } from "../../util/Constant";
import { isValidElement, isValidString } from "../../util/ApiHelper";
import OfferProductForm from "./OfferProductForm";
import {
  createExportOfferProductAction,
  getExporterOfferProductsAction,
  getExporterOfferProductsById,
} from "../../appRedux/actions/exporterOfferProductsAction";
import { fetchStart, fetchSuccess, getProductsAction } from "../../appRedux/actions";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";

const OfferProductDetailsExporter = () => {
  const location = useLocation();
  const cloneData = location.state?.cloneData;
  const dispatch = useDispatch();
  const [form] = useForm();
  const history = useHistory();
  const [dataId, setDataId] = useState();
  const { isMobile } = useGetBreakpoints();
  const { id } = useParams();
  const currency = Form.useWatch("currency", form);
  const [selectedCurrencies, setSelectedCurrencies] = useState([]);
  const productsUnitList = useSelector(
    ({ myProducts }) => myProducts.productsUnitList || []
  );
  const [productList, setProductList] = useState([]);
  let isEditDisabled = false;
  const uniqueProductsUnitList = Array.from(
    new Map(
      (productsUnitList || []).filter(Boolean).map((item) => [item.label, item])
    ).values()
  );

   const allProductList = async () => {
      try {
        dispatch(fetchStart());
        const response = await axiosInstance.get(
          `${BASE_API_CONFIG.baseURL}/products/all-product-for-offer`
        );
        const allProduct = response?.data?.data;
        setProductList(allProduct);
        console.log("Product response:", response);
      } catch (error) {
        console.error("Error fetching promotions:", error);
      } finally {
        dispatch(fetchSuccess());
      }
    };

  useEffect(() => {
    allProductList();
  },[])

  const existingExporterOffers = useSelector(
    (state) => state.exporterOfferProducts.exporterOfferProductsList?.data || []
  );

  const offerProductDetails = useSelector(
    (state) => state.exporterOfferProducts.productsDetailsById
  );
  const selectedUOM = Form.useWatch("uom", form);
  const paymentTerms = Form.useWatch("paymentTerms", form);

  const [visibleAttachments, setVisibleAttachments] = useState(1);
  const [fileList, setFileList] = useState([
    { label: "primary-image", src: "" },
    { src: "" },
    { src: "" },
    { src: "" },
  ]);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedHsCodeId , setSelectedHsCodeId] = useState(null);
  const authUser = useSelector(({ auth }) => auth.userData);

  useEffect(() => {
    if (id) {
      dispatch(getExporterOfferProductsAction());
      dispatch(getExporterOfferProductsById({ id }));
    } else {
      dispatch(getExporterOfferProductsAction());
    }
  }, [dispatch, id]);

  useEffect(() => {
    // Prefill from cloneData if present, else from offerProductDetails
    if (cloneData) {
      form.setFieldsValue({
        productName: cloneData.name,
        expiryDate: cloneData.expiryDate ? moment(cloneData.expiryDate) : undefined,
        uom: cloneData.uom,
        price: cloneData.price,
        comments: cloneData.comments,
        currency: cloneData.currency,
      });
      setSelectedProductId(cloneData.productId);
      setSelectedCategoryId(cloneData.categoryId);
      setSelectedHsCodeId(cloneData.hsCodeId);
      // Do NOT set dataId so it creates a new offer
      if (cloneData.primaryImage) {
        setFileList([
          { src: cloneData.primaryImage, label: "primary-image" },
          { src: "" },
          { src: "" },
          { src: "" },
        ]);
        setVisibleAttachments(2);
      }
    } else if (isValidElement(offerProductDetails) && isValidString(id)) {
      const expiryDate = moment(offerProductDetails?.expiryDate).format(
        "DD-MM-YYYY"
      );
      form.setFieldsValue({
        productName: offerProductDetails?.name,
        expiryDate: moment(expiryDate, "DD-MM-YYYY"),
        uom: offerProductDetails?.uom,
        price: offerProductDetails?.price,
        paymentTerms: offerProductDetails?.paymentTerms,
        comments: offerProductDetails?.comments,
        currency: offerProductDetails?.currency,
      });

      setSelectedProductId(offerProductDetails?.productId);
      setSelectedCategoryId(offerProductDetails?.categoryId);

      setDataId(id);
      let existingImages = [];

      if (typeof offerProductDetails?.primaryImage === "string") {
        existingImages = [
          { src: offerProductDetails.primaryImage, label: "primary-image" },
        ];
      } else if (Array.isArray(offerProductDetails?.primaryImage)) {
        existingImages = [...offerProductDetails.primaryImage];
      }
      const images = existingImages.slice();
      while (images.length < 4) {
        images.push({ src: "" });
      }
      setFileList(images.slice(0, 4));
      const filledImagesCount = existingImages.filter((img) => img?.src).length;
      setVisibleAttachments(Math.min(filledImagesCount + 1, 4));
    }
  }, [cloneData, form, id, offerProductDetails, productList]);

  // Separate effect to handle clone data after productList is loaded
  useEffect(() => {
    if (cloneData && productList && productList.rows && productList.rows.length > 0) {
      form.setFieldsValue({
        productName: cloneData.name,
        expiryDate: cloneData.expiryDate ? moment(cloneData.expiryDate) : undefined,
        uom: cloneData.uom,
        price: cloneData.price,
        comments: cloneData.comments,
        currency: cloneData.currency,
      });
    }
  }, [cloneData, productList, form]);

  const onFinish = (values) => {
    if (!id) {
      // const existingProduct = existingExporterOffers.find(
      //   (offer) =>
      //     offer.name?.toLowerCase() === values.productName?.toLowerCase()
      // );
      // if (existingProduct) {
      //   const newExpiryDate = moment(values.expiryDate);
      //   const existingExpiryDate = moment(existingProduct.expiryDate);

      //   if (
      //     newExpiryDate.isBefore(existingExpiryDate) ||
      //     newExpiryDate.isSame(existingExpiryDate, "day")
      //   ) {
      //     notification.warning({
      //       message: "Expiry Date Conflict",
      //       description: `This product already exists with an expiry date of ${existingExpiryDate.format(
      //         "DD-MM-YYYY"
      //       )}. 
      //           You must provide a later expiry date or can edit in the existing offer`,
      //     });
      //     return;
      //   }
      // }

      const today = moment().startOf("day");
      const existingOfferToday = existingExporterOffers.find((offer) => {
        const createdDate = moment(offer.createdAt).startOf("day");

        return (
          offer.name?.toLowerCase() === values.productName?.toLowerCase()&&
          createdDate.isSame(today)
        );

      });

      if(existingOfferToday) {
        notification.warning({
          message: "Daily Limit Reached",
          description: `You have already created an offer for "${values.productName}" today.  
        You can create a new offer tomorrow or can edit in the existing offer`,
        });
        return;
      }
    }
    const paymentTerms = values.currency === "INR" ? "FOR" : "FOB";
    const businessTypeIds = values.currency === "INR"
      ? [OFFER_PRODUCT_BUSINESS_TYPE.exporter, OFFER_PRODUCT_BUSINESS_TYPE.manufacturer_exporter]
      : [OFFER_PRODUCT_BUSINESS_TYPE.buyer];
    let selectedProductFromList;
    if (productList && Array.isArray(productList.rows)) {
      selectedProductFromList = productList.rows.find((p) => p.id === selectedProductId);
    } else {
      selectedProductFromList = undefined;
    }

    const primaryImageToSend =
      isValidString(fileList?.[0]?.src) && fileList[0].src
        ? fileList[0].src
        : selectedProductFromList?.primaryImage || "";

    const data = {
      productId: selectedProductId,
      categoryId: selectedCategoryId,
      businessTypeIds: businessTypeIds,
      hsCodeId: selectedHsCodeId,
      userId: authUser?.id,
      name: values?.productName,
      expiryDate: values?.expiryDate,
      uom: values?.uom,
      price: values?.price,
      currency: values?.currency,
      paymentTerms: paymentTerms,
      comments: values?.comments,
      primaryImage: primaryImageToSend,
      forDestination: values?.forDestination || "",
    };
    // If cloneData exists, create new offer (don't send dataId)
    const submitDataId = cloneData ? undefined : dataId;
    dispatch(createExportOfferProductAction(data, submitDataId));
  };

  const onUpload = (data) => {
    setFileList((prevFileList) => {
      const updatedList = prevFileList.map((file, index) =>
        index === data.index
          ? { ...file, src: data.src, originalName: data.originalName }
          : file
      );

      if (visibleAttachments < 4 && data.index === visibleAttachments - 1) {
        setVisibleAttachments(visibleAttachments + 1);
      }

      return updatedList;
    });
  };

  const onRemove = (data) => {
    setFileList((prevFileList) => {
      const updatedList = prevFileList.map((file, index) =>
        index === data.index ? { ...file, src: "" } : file
      );

      if (data.index === visibleAttachments - 1) {
        setVisibleAttachments(Math.max(1, visibleAttachments - 1));
      }

      return updatedList;
    });
  };
  const validateTextArea = (_, value) => {
    if (value && value.length > 1000) {
      return Promise.reject(
        new Error("Product Requirements cannot exceed 1000 characters")
      );
    }
    return Promise.resolve();
  };

  useEffect(() => {
    dispatch(getProductsAction());
  }, [dispatch]);

  return (
    <Card
      className="myexim-detail-card"
      title={
        <div className="myexim-table-title gx-text-capitalize">
          <LeftOutlined
            className={"back-icon"}
            size="large"
            onClick={() => {
              history.goBack();
            }}
          />
          {dataId ? "Edit" : "Add"} Offer Product
        </div>
      }
    >
      <OfferProductForm
        form={form}
        onFinish={onFinish}
        productList={productList}
        uniqueProductsUnitList={uniqueProductsUnitList}
        fileList={fileList}
        visibleAttachments={visibleAttachments}
        onUpload={onUpload}
        onRemove={onRemove}
        validateTextArea={validateTextArea}
        currency={currency}
        selectedUOM={selectedUOM}
        paymentTerms={paymentTerms}
        authUser={authUser}
        isEditDisabled={isEditDisabled}
        isMobile={isMobile}
        history={history}
        setSelectedProductId={setSelectedProductId}
        setSelectedCategoryId={setSelectedCategoryId}
        setSelectedHsCodeId = {setSelectedHsCodeId}
        selectedCurrencies={selectedCurrencies}
        setSelectedCurrencies={setSelectedCurrencies}
      />
    </Card>
  );
};

export default OfferProductDetailsExporter;
